import { Skeleton } from "@/app/admin/_common/ui/skeleton";

export default function LocationListSkeleton() {
  return (
    <div className="flex h-full flex-col overflow-hidden border-t border-border bg-card md:rounded-md md:border md:border-border">
      <div className="flex h-8 items-center gap-4 border-b border-border/50 bg-muted/50 px-4">
        <Skeleton className="h-3 w-24" />
        <Skeleton className="ml-auto h-3 w-32" />
        <Skeleton className="h-3 w-10" />
        <Skeleton className="h-3 w-16" />
      </div>
      {Array.from({ length: 8 }).map((_, i) => (
        <div
          key={i}
          className="flex h-[46px] items-center gap-4 border-b border-border/50 px-4 last:border-0"
        >
          <Skeleton className="h-3 w-28" />
          <Skeleton className="ml-auto h-3 w-40" />
          <Skeleton className="h-3 w-8" />
          <Skeleton className="h-3 w-16" />
          <Skeleton className="size-4 flex-none rounded" />
        </div>
      ))}
    </div>
  );
}
